import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';
import type { IUseCase } from '@/shared/contracts/use-case.contract';
import { UIError } from '@/shared/utils/ui-error';
import { OPERADOR_ENDPOINT, type OperadorSession } from '../types';

type Input = { codigo: string };

// Troca o código de uso único gerado pelo gestor pelo JWT do operador.
export class TrocarCodigoOperadorUseCase implements IUseCase<Input, OperadorSession> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute({ codigo }: Input): Promise<OperadorSession> {
    if (!codigo.trim()) {
      throw new UIError('CODIGO_OPERADOR_INVALIDO', 'Link de atendimento inválido.');
    }

    const response = await this.client.sendRequest<{ data: OperadorSession }, Input>({
      endpoint: OPERADOR_ENDPOINT,
      method: HttpMethod.POST,
      body: { codigo: codigo.trim() },
    });

    return response.data;
  }
}
